import { addNavMenuSection } from "@vendure/admin-ui/core";

export default [
  addNavMenuSection({
    id: "drip-campaigns",
    label: "Drip Campaigns",
    items: [
      // {
      //   id: "drip-campaigns",
      //   label: "Campaigns",
      //   routerLink: ["/extensions/drip-campaigns"],
      //   icon: "envelope",
      // },
      {
        id: "drip-campaigns",
        label: "Campaigns",
        routerLink: ['/extensions/drip-campaigns/marketing-automations'],
        icon: 'envelope',
      },
    ],
  }),
];
